// channelVisibility.js

const normalizeKey = (value) => String(value || '').trim();

export const normalizeChannelMemberKeys = (channel) => {
  const memberKeys = Array.isArray(channel?.memberKeys) ? channel.memberKeys : [];
  const members = Array.isArray(channel?.members) ? channel.members : [];

  const cleanMemberKeys = Array.from(new Set(
    [...memberKeys, ...members]
      .map((member) => {
        if (member && typeof member === 'object') {
          return normalizeKey(member?.userKey || member?.key || member?.id);
        }

        return normalizeKey(member);
      })
      .filter(Boolean)
  ));

  const createdBy = normalizeKey(channel?.createdBy);
  if (createdBy && !cleanMemberKeys.includes(createdBy)) {
    cleanMemberKeys.push(createdBy);
  }

  return cleanMemberKeys;
};

export const canUserSeeChannel = (channel, userKey) => {
  const cleanUserKey = normalizeKey(userKey);
  if (!cleanUserKey) return false;

  const memberKeys = normalizeChannelMemberKeys(channel);
  if (memberKeys.length === 0) return true;
  return memberKeys.includes(cleanUserKey);
};
